"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformProjectGroupMemberParsedResponse = exports.transformProjectGroupParsedResponse = void 0;
function transformProjectGroupParsedResponse(group) {
    return {
        id: group.id,
        members: group.members && group.members.map((member) => transformProjectGroupMemberParsedResponse(member)),
    };
}
exports.transformProjectGroupParsedResponse = transformProjectGroupParsedResponse;
function transformProjectGroupMemberParsedResponse(member) {
    return {
        firstName: member.first_name,
        lastName: member.last_name,
        role: member.role,
        identityId: member.identity_id,
        active: member.active,
        company: member.company,
        id: member.id,
        email: member.email,
    };
}
exports.transformProjectGroupMemberParsedResponse = transformProjectGroupMemberParsedResponse;
//# sourceMappingURL=ProjectGroup.js.map